const maintenance = {
    'plate': '車牌號碼',
    'total_mileage': '總里程 (km)',
    'last_regular_maintenance': '上次定保里程 (km)',
    'maintenance_countdown_distance': '倒數定保距離 (km)',
    'last_regular_maintenance_date': '上次定保日',
};

export default maintenance;
